import {Component, OnInit} from '@angular/core';
import {CommonComponent} from '../../shared/common/common.component';
import {NotificationsService} from '../../../services/notifications.service';
import {AccountService} from '../../../services/account.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ActivatedRoute, Router} from '@angular/router';
import {NgForm} from '@angular/forms';
import {IInternationalTargetAccount} from '../../../domain/accounts/IInternationalTargetAccount';
import {InternationalTargetAccountEntity} from '../../../entity/InternationalTargetAccountEntity';
import * as moment from 'moment';
import {ITargetAccount} from '../../../domain/accounts/ITargetAccount';
import {TargetAccountEntity} from '../../../entity/TargetAccountEntity';
import {ToastaService} from 'ngx-toasta';
import {TranslateService} from '@ngx-translate/core';
import {IProductCatalog} from '../../../domain/IProductCatalog';
import {ETargetAccountType} from '../../../enums/ETargetAccountType';
import {DialogService} from 'primeng/dynamicdialog';
import {ConfigurationService} from '../../../services/configuration.service';
import {AccountConfiguration} from '../../../domain/configurations';

@Component({
  selector: 'app-target-account',
  templateUrl: './target-account.component.html',
  styleUrls: ['./target-account.component.scss']
})

export class TargetAccountComponent extends CommonComponent implements OnInit {
  targetAccountType = ETargetAccountType.INTERNAL_CARD;
  mode: string = this.activatedRoute.snapshot.paramMap.get('mode');
  internationalTargetAccounts: IInternationalTargetAccount = new InternationalTargetAccountEntity();
  targetAccount: ITargetAccount = new TargetAccountEntity();
  targetAccountTypeName: string;
  uglyDateHolder: Date;
  sub: any;
  selectedProduct: IProductCatalog = null;
  regex = /_/g;
  today = moment();
  minDate: string;
  maxDate: string;
  configurations: AccountConfiguration;
  enableInternalTransfers: boolean;
  enableInternationalTransfers: boolean;
  accountLookUp: any;
  accountUserName: string;
  verifyData = false;
  successPopup = false;
  showAccountInfo = false;
  displayInvalidAccount = false;
  createTargetAccountBtn = false;
  invalidCardNumberMessage: string;
  constructor(
    protected router: Router,
    private activatedRoute: ActivatedRoute,
    private accountsService: AccountService,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    public translate: TranslateService,
    protected dialogService: DialogService,
    private configurationsService: ConfigurationService
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    this.configurations = this.configurationsService.account;
    this.targetAccount.accountNumber = '550296';
  }

  ngOnInit(): void {
    if (this.configurations.enableInternationalTransfers === false && this.configurations.enableInternalTransfers === false) {
      this.router.navigateByUrl('account/balance');
    }
    this.enableInternationalTransfers = this.configurations.enableInternationalTransfers;
    this.enableInternalTransfers = this.configurations.enableInternalTransfers;
    scrollTo({top: 0, left: 0, behavior: 'smooth'});
    this.maxDate = this.today.subtract(18, 'years').format('MM/DD/YYYY');
    this.minDate = this.today.subtract(100 - 18, 'years').format('MM/DD/YYYY');
    this.sub = history.state;
    switch (this.sub.type) {
      case this.eTargetAccountTypes.INTERNAL_CARD:
        this.targetAccountType = this.eTargetAccountTypes.INTERNAL_CARD;
        this.targetAccountTypeName = this.translate.instant('accounts.target_account.card_to_card');
        this.targetAccount = this.sub;
        this.targetAccount.type = this.eTargetAccountTypes.INTERNAL_CARD;
        this.targetAccount.institution = 'The Alterna Sin Fronteras Card';
        this.targetAccount.institutionId = '00000';
        this.targetAccount.frequent = false;
        break;
      case this.eTargetAccountTypes.INTERNATIONAL:
        this.targetAccountType = this.eTargetAccountTypes.INTERNATIONAL;
        this.targetAccountTypeName = this.translate.instant('accounts.target_account.mex_account');
        this.internationalTargetAccounts = this.sub;
        if (this.internationalTargetAccounts.birthDate) {
          this.uglyDateHolder = new Date(this.internationalTargetAccounts.birthDate);
          this.uglyDateHolder.setTime(this.uglyDateHolder.getTime() + this.uglyDateHolder.getTimezoneOffset() * 60 * 1000);
        }
        this.internationalTargetAccounts.type = this.eTargetAccountTypes.INTERNATIONAL;
        this.internationalTargetAccounts.country = 'MX';
        this.internationalTargetAccounts.status = 2;
        break;
    }

  }

  onBack(form: NgForm) {
    form.resetForm();
    this.router.navigate(['/account/transfers']);
  }

  onCancel() {
    this.router.navigate(['/account/transfers']);
  }

  onSubmitLocalAccount(form: NgForm) {
    this.loadingModalOn();
    switch (this.mode) {
      case 'NEW':
        this.targetAccountTypeName = 'Card-to-card';
        this.targetAccount.type = this.eTargetAccountTypes.INTERNAL_CARD;
        this.accountsService.createTargetAccount(this.targetAccount).subscribe(
          (response: any) => {
            this.successPopup = true;
            form.resetForm();
            //this.router.navigate(['/account/transfers']);
            this.loadingModalOff();
          }, error => {
            this.msgError(error);
            this.targetAccount.accountNumber = '550296';
            this.targetAccount.alias = '';
            this.showAccountInfo = false;
            this.loadingModalOff();
          }
        );
        break;
      case 'EDIT':
        this.accountsService.editTargetAccount(this.targetAccount).subscribe(
          (response: any) => {
            this.successPopup = true;
            form.resetForm();
            //this.router.navigate(['/account/transfers']);
            this.loadingModalOff();
          }, error => {
            this.msgError(error);
            this.loadingModalOff();
          }
        );
        break;
    }
  }
  // Function to verify that the account exists
  verifyTargetAccount(cardNumber: string) {
    this.loadingModalOn();
    if (!cardNumber || cardNumber.length < 16 || cardNumber === this.accountsService?.cardNumber){
      this.loadingModalOff();
      this.displayInvalidAccount = true;
      if (cardNumber === this.accountsService?.cardNumber){
        this.invalidCardNumberMessage = this.translate.instant('accounts.transfers.invalid-own-card-number');
      }else {
        this.invalidCardNumberMessage = this.translate.instant('accounts.transfers.invalid-card-number');
      }
    }else {
      this.accountsService.searchCard(cardNumber).subscribe(
        (response: any) => {
          this.accountLookUp = response;
          this.accountUserName = this.accountLookUp.maskedFirstName.replaceAll('X', '●') +
            ' ' + this.accountLookUp.maskedLastName.replaceAll('X', '●');
          this.loadingModalOff();
          this.verifyData = true;
        }, error => {

          this.loadingModalOff();
          this.displayInvalidAccount = true;
          this.invalidCardNumberMessage = error?.error?.message;
        }
      );
    }
  }
  // Function to keep first six digits
  onInputChange(event: any) {
    const inputValue = event.target.value;
    const textWithoutSpace = inputValue.replace(/\s/g, '');
    if (textWithoutSpace === 16) {
      textWithoutSpace.substring(7);
      this.targetAccount.accountNumber = '550296' + textWithoutSpace;
    } else if (inputValue.length < 6 || event.key === 'Delete') {
      this.targetAccount.accountNumber = '550296';
    }
  }
  // Function to confirm target account
  confirmAccount(){
    this.showAccountInfo = true;
    this.verifyData = false;
    this.createTargetAccountBtn = true;
  }

  successConfirm(){
    this.router.navigate(['/account/transfers']);
  }
}
